import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { ShoppingCart, Headphones, Package } from 'lucide-react';

export default function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get('/orders').then(r => setOrders(r.data)).catch(() => {});
  }, []);

  const statusColor = (s) => {
    if (s === 'completed') return 'bg-emerald-500/10 text-emerald-600';
    if (s === 'free') return 'bg-[#1A9DA5]/10 text-[#1A9DA5]';
    return 'bg-amber-500/10 text-amber-600';
  };

  return (
    <div className="space-y-6" data-testid="orders-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight font-['Outfit']">Orders</h1>
        <p className="text-muted-foreground mt-1">{orders.length} orders</p>
      </div>

      {orders.length === 0 ? (
        <Card>
          <CardContent className="p-12 text-center">
            <ShoppingCart className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-lg font-medium">No orders yet</p>
            <p className="text-sm text-muted-foreground">Orders will appear here when customers make purchases</p>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Order ID</TableHead>
                <TableHead>Customer</TableHead>
                <TableHead>Product</TableHead>
                <TableHead>Amount</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orders.map(o => (
                <TableRow key={o.id} data-testid={`order-row-${o.id}`}>
                  <TableCell className="font-mono text-xs">{o.id?.slice(0, 8)}...</TableCell>
                  <TableCell className="text-sm">{o.customer_email || 'Anonymous'}</TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      {o.product_type === 'package' ? <Package className="w-3.5 h-3.5 text-purple-500 shrink-0" /> : <Headphones className="w-3.5 h-3.5 text-[#1A9DA5] shrink-0" />}
                      <span className="text-sm truncate max-w-[200px]">{o.product_title || o.product_id?.slice(0, 8) || '—'}</span>
                    </div>
                  </TableCell>
                  <TableCell className="font-semibold">{o.amount === 0 || o.payment_status === 'free' ? <span className="text-[#1A9DA5]">Free</span> : `$${o.amount}`}</TableCell>
                  <TableCell><Badge variant="outline" className={statusColor(o.status || o.payment_status)}>{o.status || o.payment_status}</Badge></TableCell>
                  <TableCell className="text-muted-foreground text-sm">{o.created_at ? new Date(o.created_at).toLocaleDateString() : ''}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
